export const translations = {
	nav: {
		title: 'Nabigazioa',
		app: 'Dohaintza ziurtagiria',
	},
	footer: {
		poweredBy: 'Eginak',
		copyright: '© {{year}} WorldCoo. Eskubide guztiak gordeta.',
		termsAndConditions: 'Termino eta baldintzak',
		privacyPolicy: 'Pribatutasun politika',
	},
	categories: {
		basicNeeds: 'Ura eta Energia',
		humanRights: 'Giza Eskubideak',
		education: 'Hezkuntza',
		emergency: 'Larrialdiak',
		feeding: 'Gosea eta Elikadura Segurtasuna',
		environment: 'Ingurumena',
		habitat: 'Etxebizitza eta Pobrezia',
		health: 'Osasuna',
	},
	statistics: {
		campaigns: 'Kanpainak',
		donations: 'Dohaintzak',
		collected: 'Bilduta',
		collectedFromBudget: '{{budget}}-ko helburua',
	},
	filters: {
		year: 'Urtea',
		state: 'Egoera',
		cause: 'Kausa',
		active: 'Aktiboa',
		finished: 'Amaituta',
		default: 'Lehenetsita',
		toggle: 'Aldatu {{value}}',
	},
	actions: {
		close: 'Itxi',
		search: 'Bilatu edozer',
		filter: 'Iragazi',
		viewCampaign: 'Kanpaina ikusi',
		makeDonation: 'Dohaintza egin',
		donate: 'Dohaintza eman',
		selectLanguage: 'Hizkuntza aukeratu',
		backToHome: 'Hasierara itzuli',
		funded: 'Finantzatuta',
		clear: 'Iragazkiak Garbitu',
		apply: 'Aplikatu',
		goBack: 'Itzuli',
		previous: 'Aurrekoa',
		next: 'Hurrengoa',
	},
	portal: {
		heroButton: 'Hasi donatzen',
		campaigns: {
			title: 'Kanpainak',
			description: 'Gure ekimenak arakatu eta gehien inspiratzen zaituen kausa aukeratu',
			notFound: 'Ez dago kanpainarik',
		},
		campaignFunded: 'Kanpaina finantzatuta',
		percentageFunded: '%{{percentage}} Finantzatuta',
		aCampaignFrom: 'Kanpaina bat: {{ngoName}}',
		beneficiaries: 'Onuradunak',
		directBeneficiaries: '{{count}} zuzeneko',
		indirectBeneficiaries: '{{count}} zeharkako',
		sdgs: {
			title: 'Garapen Jasangarrirako Helburuak',
			1: 'Pobreziarik Ez',
			2: 'Goserik Zero',
			3: 'Osasuna eta Ongizatea',
			4: 'Kalitatezko Hezkuntza',
			5: 'Genero Berdintasuna',
			6: 'Ur Garbia eta Saneamendua',
			7: 'Energia Eskuragarria eta Ez Kutsatzailea',
			8: 'Lan Duina eta Hazkunde Ekonomikoa',
			9: 'Industria, Berrikuntza eta Azpiegiturak',
			10: 'Desberdintasunen Murrizketa',
			11: 'Hiri eta Komunitate Jasangarriak',
			12: 'Ekoizpen eta Kontsumo Arduratsua',
			13: 'Klimaren Aldeko Ekintza',
			14: 'Itsas Bizitza',
			15: 'Lurreko Bizitza',
			16: 'Bakea, Justizia eta Instituzio Sendoak',
			17: 'Helburuak Lortzeko Aliantzak',
		},
	},
	faq: {
		title: 'Galdera arruntak',
		description: 'Gure emaileen ohiko zalantzei erantzunak.',
	},
	campaign: {
		objectives: 'Kanpainaren helburuak',
		description: 'Deskribapena',
		activities: 'Jarduerak',
		beneficiaries: 'Nork izango du onura?',
		updatesAndLinks: 'Informazio gehiago eta estekak',
		from: 'Noiztik:',
		until: 'Noiz arte:',
	},
	campaigns: {
		notTranslated: 'Proiektu hau oraindik ez dago zure hizkuntzan eskuragarri.',
	},
	placeholders: {
		amount: 'Beste zenbateko bat',
	},
	donate: {
		title: 'Egin zure dohaintza',
		details: {
			title: 'Gehitu zure datuak jarraitzeko',
			subtitle: 'Osatu zure datuak zure dohaintza burutzeko. Zure zerga ziurtagiria ere eska dezakezu hemen.',
		},
		certificate: {
			title: 'Berreskuratu {{amount}} arte',
			subtitle:
				'Egiaztatu zure dohaintza klik batekin eta automatikoki agertuko da zure Errenta aitorpenaren zirriborroan.',
		},
	},
	errors: {
		required: 'Eremu hau derrigorrezkoa da',
		invalidExtref: 'Kodea baliogabea da, formatu hau izan behar du: {{format}}',
		email: 'Helbide elektronikoa gaizki formatuta dago.',
		emailAlreadyExists: 'Helbide elektroniko hau dagoeneko erabilita dago.',
		password: 'Zure pasahitzak 6 karaktere edo gehiago izan behar ditu.',
		confirmationCode: 'Mesedez, sartu berrespen kodea.',
		documentType: 'Dokumentu mota baliogabea',
		termsAndConditions: 'Baldintzak eta terminoak onartu behar dituzu',
		amount: 'Mesedez, hautatu edo sartu zenbateko bat baliozkoa.',
		signIn: 'Errorea saioa hastean',
		emailsDoNotMatch: 'Helbide elektronikoak ez datoz bat.',
		passwordsDoNotMatch: 'Pasahitzak ez datoz bat.',
		imageFormat: 'Mesedez, askatu irudi fitxategi bat',
		camera: 'Ezin da kamerara sartu. Mesedez, ziurtatu baimena eman duzula.',
		expiredCode: 'Kodea iraungi da.',
		codeMismatch: 'Kodea okerra da. Mesedez, saiatu berriro.',
		notAuthorized: 'Egiaztagiri okerrak. Mesedez, saiatu berriro.',
		userDoesNotExist: 'Erabiltzailea ez da existitzen.',
		userNotConfirmed: 'Erabiltzailea ez dago baieztatuta. Mesedez, baieztatu lehenik zure helbide elektronikoa.',
		userAlreadyConfirmed: 'Erabiltzailea dagoeneko baieztatu da.',
		documentNumberExists: 'Dokumentu zenbakia dagoeneko erabilita dago.',
		limitExceeded: 'Saiakera muga gainditu duzu. Mesedez, saiatu berriro beranduago.',
		invalidPassword: 'Pasahitza baliogabea da, gutxienez 6 karaktere izan behar ditu eta ezin du hutsunerik izan.',
		captchaFailed: 'CAPTCHA verification failed. Please try again.',
		internal: 'Barkatu, arazo bat egon da, gure taldea dagoeneko jakinarazi da, saiatu berriro beranduago.',
	},
	documentTypes: {
		id: 'NAN',
		passport: 'Pasaportea',
		taxId: 'Zerga identifikazioa',
		nie: 'NIE',
		others: 'Bestelakoak',
	},
	labels: {
		code: 'Kodea',
		email: 'Posta elektronikoa',
		repeatEmail: 'Errepikatu zure posta elektronikoa',
		password: 'Pasahitza',
		confirmPassword: 'Pasahitza berretsi',
		amount: 'Dohaintza zenbatekoa',
		documentType: 'Dokumentu mota',
		documentNumber: 'Dokumentu zenbakia',
		name: 'Izena',
		lastName: 'Abizena',
		streetName: 'Kale izena',
		streetNumber: 'Zenbakia',
		additionalInfo: 'Informazio gehigarria',
		postalCode: 'Posta kodea',
		city: 'Hiria',
		country: 'Herrialdea',
		region: 'Eskualdea',
		province: 'Probintzia',
		certificate: 'Zerga ziurtagiria jaso nahi dut',
		termsAndConditions1:
			'Informazio hau zure dohaintzak jasotzen dituzten erakundeekin bakarrik partekatuko da dagokion zerga ziurtagiria sortzeko. Irakurri ',
		termsAndConditions2: 'baldintzak eta terminoak',
		language: 'Hizkuntza',
	},
	checkout: {
		title: 'Ordainketa metodoa',
	},
	recaptcha: {
		description: 'reCAPTCHA-k babestua.',
		privacy: 'Pribatutasuna',
		terms: 'Baldintzak',
	},
	thanks: {
		title: 'Eskerrik asko\n zure dohaintzagatik!',
		description:
			'Laster jasoko duzu baieztapen-mezu bat xehetasun guztiekin. Elkarrekin etorkizun hobea eraikitzen ari gara!',
	},
	termsAndConditions: {
		title: 'Datuen Babesaren Baldintzak',
		labelText: 'Irakurri, ulertu eta onartu ditut ',
		labelLink: '{{name}}-ren Datuen Babesaren baldintzak',
		accept: 'Irakurri, ulertu eta onartu ditut',
		responsible: {
			title: 'Arduradunak',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Helburua',
			description:
				'Negozio-harremana bere alderdi guztietan kudeatzea, baita zure dohaintza eta zure ziurtagiri-eskaera ere, eta komunikazio komertzialak bide elektronikoz bidaltzea.',
			descriptionNgo:
				'GKEen proiektuetarako funts-bilketa, GKEari eta funtsak eman dizkiozun proiektuaren bilakaerari buruz informatuta mantentzea eta zerga-kenkarien ziurtagiriak jaulkitzea.',
		},
		legitimacy: {
			title: 'Legitimitatea',
			description: 'Zure datuen tratamendurako oinarri legala zure baimena lortzea da.',
		},
		recipients: {
			title: 'Hartzaileak',
			description: 'Datuak ez dira hirugarrenei lagako, horretarako lege-betebeharra egon ezean.',
		},
		rights: {
			title: 'Eskubideak',
			description:
				'Datuetara sartzeko, zuzentzeko eta ezabatzeko eskubidea duzu, baita beste eskubide batzuk ere, informazio gehigarrian azaltzen den bezala.',
		},
		additionalInfo: {
			title: 'Informazio gehigarria',
			description:
				'Datuen Babesari buruzko informazio gehigarri eta xehatua gure orrialde <a href="https://www.worldcoo.com/gdpr">web</a> -ean kontsulta dezakezu edo <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a> helbidera idatziz.',
			descriptionNgo:
				'Datuen Babesari buruzko informazio gehigarri eta xehatua GKE bakoitzaren webgunean kontsulta dezakezu.\n\n<b>{{ngoName}}</b>',
		},
	},
};
